import React from "antd";

import style from "./DashboardLabel.module.css";

export const DashboardLabel = ({title}) => {

    return <span className={style.label}>{title}</span>

}